module.exports = __webpack_public_path__ + "img/icon_07.d395064c.png";